/**
 * DarkModeToggle — Lune | Toggle | Soleil
 * Design inspiré de Shimah Mahdavi
 * Les icônes sont à l'extérieur du slider
 */
import React from 'react';

const DarkModeToggle = ({ darkMode, setDarkMode }) => {
  const toggle = () => {
    const newMode = !darkMode;
    setDarkMode(newMode);
    localStorage.setItem('ekynair-dark-mode', JSON.stringify(newMode));
  };

  return (
    <div
      onClick={toggle}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: 'pointer',
        userSelect: 'none'
      }}
    >
      {/* Lune à gauche */}
      <span style={{
        fontSize: '18px',
        opacity: darkMode ? 1 : 0.4,
        transition: 'opacity 0.3s',
        filter: darkMode ? 'none' : 'grayscale(1)',
        lineHeight: 1
      }}>🌙</span>

      {/* Track */}
      <div style={{
        position: 'relative',
        width: '44px',
        height: '24px',
        borderRadius: '12px',
        background: darkMode ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.4)',
        transition: 'background 0.3s',
        flexShrink: 0
      }}>
        {/* Knob */}
        <div style={{
          position: 'absolute',
          top: '2px',
          left: darkMode ? '2px' : '22px',
          width: '20px',
          height: '20px',
          borderRadius: '50%',
          background: '#fff',
          boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
          transition: 'left 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
        }} />
      </div>

      {/* Soleil à droite */}
      <span style={{
        fontSize: '18px',
        opacity: darkMode ? 0.4 : 1,
        transition: 'opacity 0.3s',
        filter: darkMode ? 'grayscale(1)' : 'none',
        lineHeight: 1
      }}>☀️</span>
    </div>
  );
};

export default DarkModeToggle;
